const countries = [
  { code: 1, label: "United States", iso2: "US" },
  { code: 1, label: "Canada", iso2: "CA" },
  { code: 7, label: "Russian Federation", iso2: "RU" },
  { code: 20, label: "Egypt", iso2: "EG" },
  { code: 27, label: "South Africa", iso2: "ZA" },
  { code: 30, label: "Greece", iso2: "GR" },
  { code: 31, label: "Netherlands", iso2: "NL" },
  { code: 32, label: "Belgium", iso2: "BE" },
  { code: 33, label: "France", iso2: "FR" },
  { code: 34, label: "Spain", iso2: "ES" },
  { code: 36, label: "Hungary", iso2: "HU" },
  { code: 39, label: "Italy", iso2: "IT" },
  { code: 40, label: "Romania", iso2: "RO" },
  { code: 41, label: "Switzerland", iso2: "CH" },
  { code: 43, label: "Austria", iso2: "AT" },
  { code: 44, label: "United Kingdom", iso2: "GB" },
  { code: 45, label: "Denmark", iso2: "DK" },
  { code: 46, label: "Sweden", iso2: "SE" },
  { code: 47, label: "Norway", iso2: "NO" },
  { code: 48, label: "Poland", iso2: "PL" },
  { code: 49, label: "Germany", iso2: "DE" },
  { code: 51, label: "Peru", iso2: "PE" },
  { code: 52, label: "Mexico", iso2: "MX" },
  { code: 53, label: "Cuba", iso2: "CU" },
  { code: 54, label: "Argentina", iso2: "AR" },
  { code: 55, label: "Brazil", iso2: "BR" },
  { code: 56, label: "Chile", iso2: "CL" },
  { code: 57, label: "Colombia", iso2: "CO" },
  { code: 58, label: "Venezuela", iso2: "VE" },
  { code: 60, label: "Malaysia", iso2: "MY" },
  { code: 61, label: "Australia", iso2: "AU" },
  { code: 62, label: "Indonesia", iso2: "ID" },
  { code: 63, label: "Philippines", iso2: "PH" },
  { code: 64, label: "New Zealand", iso2: "NZ" },
  { code: 65, label: "Singapore", iso2: "SG" },
  { code: 66, label: "Thailand", iso2: "TH" },
  { code: 81, label: "Japan", iso2: "JP" },
  { code: 82, label: "Korea- Republic of", iso2: "KR" },
  { code: 84, label: "Viet Nam", iso2: "VN" },
  { code: 86, label: "China", iso2: "CN" },
  { code: 90, label: "Turkey", iso2: "TR" },
  { code: 91, label: "India", iso2: "IN" },
  { code: 92, label: "Pakistan", iso2: "PK" },
  { code: 93, label: "Afghanistan", iso2: "AF" },
  { code: 94, label: "Sri Lanka", iso2: "LK" },
  { code: 95, label: "Myanmar", iso2: "MM" },
  { code: 98, label: "Iran", iso2: "IR" },
  { code: 212, label: "Morocco", iso2: "MA" },
  { code: 213, label: "Algeria", iso2: "DZ" },
  { code: 216, label: "Tunisia", iso2: "TN" },
  { code: 218, label: "Libya", iso2: "LY" },
  { code: 220, label: "Gambia", iso2: "GM" },
  { code: 221, label: "Senegal", iso2: "SN" },
  { code: 222, label: "Mauritania", iso2: "MR" },
  { code: 223, label: "Mali", iso2: "ML" },
  { code: 224, label: "Guinea", iso2: "GN" },
  { code: 225, label: "Cote D'Ivoire", iso2: "CI" },
  { code: 226, label: "Burkina Faso", iso2: "BF" },
  { code: 227, label: "Niger", iso2: "NE" },
  { code: 228, label: "Togo", iso2: "TG" },
  { code: 229, label: "Benin", iso2: "BJ" },
  { code: 230, label: "Mauritius", iso2: "MU" },
  { code: 231, label: "Liberia", iso2: "LR" },
  { code: 232, label: "Sierra Leone", iso2: "SL" },
  { code: 233, label: "Ghana", iso2: "GH" },
  { code: 234, label: "Nigeria", iso2: "NG" },
  { code: 235, label: "Chad", iso2: "TD" },
  { code: 236, label: "Central African Republic", iso2: "CF" },
  { code: 237, label: "Cameroon", iso2: "CM" },
  { code: 238, label: "Cape Verde", iso2: "CV" },
  { code: 239, label: "Sao Tome and Principe", iso2: "ST" },
  { code: 240, label: "Equatorial Guinea", iso2: "GQ" },
  { code: 241, label: "Gabon", iso2: "GA" },
  { code: 242, label: "Congo", iso2: "CG" },
  { code: 243, label: "Congo- Democratic Republic of the", iso2: "CD" },
  { code: 244, label: "Angola", iso2: "AO" },
  { code: 245, label: "Guinea-Bissau", iso2: "GW" },
  { code: 246, label: "British Indian Ocean Territory", iso2: "IO" },
  { code: 247, label: "Ascension Island", iso2: "AC" },
  { code: 248, label: "Seychelles", iso2: "SC" },
  { code: 249, label: "Sudan", iso2: "SD" },
  { code: 250, label: "Rwanda", iso2: "RW" },
  { code: 251, label: "Ethiopia", iso2: "ET" },
  { code: 252, label: "Somalia", iso2: "SO" },
  { code: 253, label: "Djibouti", iso2: "DJ" },
  { code: 254, label: "Kenya", iso2: "KE" },
  { code: 255, label: "Tanzania", iso2: "TZ" },
  { code: 256, label: "Uganda", iso2: "UG" },
  { code: 257, label: "Burundi", iso2: "BI" },
  { code: 258, label: "Mozambique", iso2: "MZ" },
  { code: 260, label: "Zambia", iso2: "ZM" },
  { code: 261, label: "Madagascar", iso2: "MG" },
  { code: 262, label: "French Southern and Antarctic Lands", iso2: "TF" },
  { code: 263, label: "Zimbabwe", iso2: "ZW" },
  { code: 264, label: "Namibia", iso2: "NA" },
  { code: 265, label: "Malawi", iso2: "MW" },
  { code: 266, label: "Lesotho", iso2: "LS" },
  { code: 267, label: "Botswana", iso2: "BW" },
  { code: 268, label: "Swaziland", iso2: "SZ" },
  { code: 269, label: "Comoros", iso2: "KM" },
  { code: 290, label: "Saint Helena", iso2: "SH" },
  { code: 291, label: "Eritrea", iso2: "ER" },
  { code: 297, label: "Aruba", iso2: "AW" },
  { code: 298, label: "Faroe Islands", iso2: "FO" },
  { code: 299, label: "Greenland", iso2: "GL" },
  { code: 350, label: "Gibraltar", iso2: "GI" },
  { code: 351, label: "Portugal", iso2: "PT" },
  { code: 352, label: "Luxembourg", iso2: "LU" },
  { code: 353, label: "Ireland", iso2: "IE" },
  { code: 354, label: "Iceland", iso2: "IS" },
  { code: 355, label: "Albania", iso2: "AL" },
  { code: 356, label: "Malta", iso2: "MT" },
  { code: 357, label: "Cyprus- Republic of", iso2: "CY" },
  { code: 358, label: "Finland", iso2: "FI" },
  { code: 370, label: "Lithuania", iso2: "LT" },
  { code: 371, label: "Latvia", iso2: "LV" },
  { code: 372, label: "Estonia", iso2: "EE" },
  { code: 373, label: "Moldova", iso2: "MD" },
  { code: 374, label: "Armenia", iso2: "AM" },
  { code: 375, label: "Belarus", iso2: "BY" },
  { code: 376, label: "Andorra", iso2: "AD" },
  { code: 377, label: "Monaco", iso2: "MC" },
  { code: 378, label: "San Marino", iso2: "SM" },
  { code: 380, label: "Ukraine", iso2: "UA" },
  { code: 381, label: "Serbia", iso2: "RS" },
  { code: 382, label: "Montenegro", iso2: "ME" },
  { code: 385, label: "Croatia", iso2: "HR" },
  { code: 386, label: "Slovenia", iso2: "SI" },
  { code: 387, label: "Bosnia and Herzegovina", iso2: "BA" },
  { code: 389, label: "Macedonia", iso2: "MK" },
  { code: 420, label: "Czech Republic", iso2: "CZ" },
  { code: 421, label: "Slovakia", iso2: "SK" },
  { code: 423, label: "Liechtenstein", iso2: "LI" },
  { code: 500, label: "Falkland Islands", iso2: "FK" },
  { code: 501, label: "Belize", iso2: "BZ" },
  { code: 502, label: "Guatemala", iso2: "GT" },
  { code: 503, label: "El Salvador", iso2: "SV" },
  { code: 504, label: "Honduras", iso2: "HN" },
  { code: 505, label: "Nicaragua", iso2: "NI" },
  { code: 506, label: "Costa Rica", iso2: "CR" },
  { code: 507, label: "Panama", iso2: "PA" },
  { code: 508, label: "Saint Pierre and Miquelon", iso2: "PM" },
  { code: 509, label: "Haiti", iso2: "HT" },
  { code: 590, label: "Guadeloupe", iso2: "GP" },
  { code: 591, label: "Bolivia", iso2: "BO" },
  { code: 592, label: "Guyana", iso2: "GY" },
  { code: 593, label: "Ecuador", iso2: "EC" },
  { code: 594, label: "French Guiana", iso2: "GF" },
  { code: 595, label: "Paraguay", iso2: "PY" },
  { code: 596, label: "Martinique", iso2: "MQ" },
  { code: 597, label: "Suriname", iso2: "SR" },
  { code: 598, label: "Uruguay", iso2: "UY" },
  { code: 599, label: "Netherlands Antilles", iso2: "AN" },
  { code: 670, label: "Timor-Leste", iso2: "TL" },
  { code: 672, label: "Norfolk Island", iso2: "NF" },
  { code: 673, label: "Brunei Darussalam", iso2: "BN" },
  { code: 674, label: "Nauru", iso2: "NR" },
  { code: 675, label: "Papua New Guinea", iso2: "PG" },
  { code: 676, label: "Tonga", iso2: "TO" },
  { code: 677, label: "Solomon Islands", iso2: "SB" },
  { code: 678, label: "Vanuatu", iso2: "VU" },
  { code: 679, label: "Fiji", iso2: "FJ" },
  { code: 680, label: "Palau", iso2: "PW" },
  { code: 681, label: "Wallis and Futuna Islands", iso2: "WF" },
  { code: 682, label: "Cook Islands", iso2: "CK" },
  { code: 683, label: "Niue", iso2: "NU" },
  { code: 685, label: "Samoa", iso2: "WS" },
  { code: 686, label: "Kiribati", iso2: "KI" },
  { code: 687, label: "New Caledonia", iso2: "NC" },
  { code: 688, label: "Tuvalu", iso2: "TV" },
  { code: 689, label: "French Polynesia", iso2: "PF" },
  { code: 690, label: "Tokelau", iso2: "TK" },
  { code: 691, label: "Micronesia", iso2: "FM" },
  { code: 692, label: "Marshall Islands", iso2: "MH" },
  { code: 699, label: "United States Minor Outlying Islands", iso2: "UM" },
  { code: 850, label: "Korea- Democratic People's Republic of", iso2: "KP" },
  { code: 852, label: "Hong Kong", iso2: "HK" },
  { code: 853, label: "Macao", iso2: "MO" },
  { code: 855, label: "Cambodia", iso2: "KH" },
  { code: 856, label: "Laos", iso2: "LA" },
  { code: 872, label: "Pitcairn", iso2: "PN" },
  { code: 880, label: "Bangladesh", iso2: "BD" },
  { code: 886, label: "Taiwan", iso2: "TW" },
  { code: 960, label: "Maldives", iso2: "MV" },
  { code: 961, label: "Lebanon", iso2: "LB" },
  { code: 962, label: "Jordan", iso2: "JO" },
  { code: 963, label: "Syria", iso2: "SY" },
  { code: 964, label: "Iraq", iso2: "IQ" },
  { code: 965, label: "Kuwait", iso2: "KW" },
  { code: 966, label: "Saudi Arabia", iso2: "SA" },
  { code: 967, label: "Yemen", iso2: "YE" },
  { code: 968, label: "Oman", iso2: "OM" },
  { code: 970, label: "Palestine", iso2: "PS" },
  { code: 971, label: "United Arab Emirates", iso2: "AE" },
  { code: 972, label: "Israel", iso2: "IL" },
  { code: 973, label: "Bahrain", iso2: "BH" },
  { code: 974, label: "Qatar", iso2: "QA" },
  { code: 975, label: "Bhutan", iso2: "BT" },
  { code: 976, label: "Mongolia", iso2: "MN" },
  { code: 977, label: "Nepal", iso2: "NP" },
  { code: 992, label: "Tajikistan", iso2: "TJ" },
  { code: 993, label: "Turkmenistan", iso2: "TM" },
  { code: 994, label: "Azerbaijan", iso2: "AZ" },
  { code: 995, label: "Georgia", iso2: "GE" },
  { code: 996, label: "Kyrgyz Republic", iso2: "KG" },
  { code: 998, label: "Uzbekistan", iso2: "UZ" },
];

const genderOptions = [
  "Male",
  "Female",
  "Other",
  "Prefer not to say",
];

const qualificationOptions = [
  "Post Doctoral",
  "Ph.D",
  "Post-Masters",
  "Masters",
  "Pre-Masters",
  "Bachelors",
  "Pre-Bachelors",
  "Associate",
  "Diploma",
  "Vocational",
  "High School",
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export {
  countries,
  genderOptions,
  qualificationOptions,
  months,
};
